import { ReactElement, useEffect } from 'react';
import useUrlParams from '../hooks/utility/useUrlParams';
import { UTMInterface } from '../services/exports/Interfaces';
import { SESSION_STORAGE_KEYS } from '../services/exports/Constants';

interface Props {
  children: ReactElement;
}

export default function TrackingProvider({ children }: Props) {
  const params = useUrlParams();

  const utm: UTMInterface = {
    utm_source: params?.utm_source ?? document.referrer,
    utm_medium: params?.utm_medium,
    utm_campaign: params?.utm_campaign,
    utm_advertisement_id: params?.utm_advertisement_id ?? params?.gclid ?? params?.fbclid,
  };

  useEffect(() => {
    if (utm.utm_source || utm.utm_advertisement_id) {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.utm, JSON.stringify(utm));
    }
  }, []);

  return children;
}
